/**
 * Modal content position and alignment helpers for layout (e.g. GlobalMenuModal).
 */

export interface ModalContentPosition {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

/**
 * Get content alignment for menu modals
 * Returns 'flex-start' for consistent alignment
 */
export const getModalContentAlignment = (): 'flex-start' => {
  return 'flex-start';
};

/**
 * Full-screen position for drawer wrapper (so inner panel can sit on the right and slide)
 */
export const getDrawerWrapperPosition = (): ModalContentPosition => {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
};



